import { defineFeature } from "../../app/feature";
import { KnowledgeQueryPage } from "./KnowledgeQueryPage";
import { SegmentPage } from "./SegmentPage";

/** Governed query (task 4140.6; DESIGN-SPEC 26.3): a question class and a question return an answer
 * with citations to exact segments, or a decline with its reason. For proof and consultant use, not
 * a general chatbot. Owned by the knowledge lane. */
export default defineFeature({
  id: "knowledge-query",
  title: "Knowledge query",
  routes: [
    { path: "/knowledge-query", Component: KnowledgeQueryPage },
    { path: "/knowledge-query/segments/:segmentId", Component: SegmentPage },
  ],
  nav: { label: "Knowledge query", path: "/knowledge-query", section: "Knowledge Query", order: 10 },
  permissions: ["engagement.read"],
});
